import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const componentsFooter: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/components-footer`),
};

export default componentsFooter;
